import { ContentType } from "./http-client";

export class LegalNotices {
  constructor(http) {
    this.http = http;
  }

  generate = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/legal-notices/generate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  issue = (rentalId, noticeId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/legal-notices/${noticeId}/issue`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  list = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/legal-notices`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
